"use client";
import { useDotButton } from "../../design1/components/Testimonials";
import React, { useCallback, useEffect } from "react";
import Pagination from "../components/Pagination";
import useEmblaCarousel from "embla-carousel-react";
import { GroupHeader } from "src/app/components/ui/Headers";
import { PersonCard } from "../Branches2";
import { useCompanyStaff } from "src/app/lib/useCompanyStaff";
import Skeleton from "react-loading-skeleton";
import { MemberType } from "src/types";
import { useDirectors } from "src/app/lib/useCompanyDirector";
const MeetTeam2 = () => {
  const { data, isLoading } = useCompanyStaff();

  const isDemoMode = process.env.NEXT_PUBLIC_DEMO_MODE === "true";

  const { data: directorsData } = useDirectors();

  const staff: MemberType[] = [
    ...(!isDemoMode ? (directorsData || []) : []),
    ...(data?.staff || []),
  ];
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: "start",
  });

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);


  const onSelect = useCallback(() => {


    if (!emblaApi) return;
  
  }, [emblaApi]);
  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on("select", onSelect);
    onSelect();
  }, [emblaApi, onSelect]);

  // if (!isDemoMode && !isLoading && data?.staff.length < 1) {
  //   return null;
  // }
  return (
    <section className="py-14 overflow-hidden">
      <div className="wrapper">
        <GroupHeader
          max={2000}
          subheader="Meet the dedicated professionals behind our success, each bringing expertise and passion to deliver exceptional real estate services."
          header="Introducing Our Team"
        />
        <div ref={emblaRef} className="items overflow-hidden mt-20 gap-4">
          <div className="parent flex">
            {isLoading ? (
              <Skeleton count={4} height={410} width={360} />
            ) : staff && staff.length > 0 ? (
              staff.map((item, index) => (
                <div
                  key={index}
                  className="w-[max(25%,360px)] h-[410px] pr-8 select-none flex justify-center shrink-0"
                >
                  <PersonCard {...item} />
                </div>
              ))
            ) : (
              <div className="text-center w-full mb-6">
                No staff information attached yet. Please try again later.
              </div>
            )}
          </div>
        </div>

        {staff && staff.length > 0 && (
          <div className="pagination mt-10">
            <Pagination
              scrollSnaps={scrollSnaps}
              selectedIndex={selectedIndex}
              onDotButtonClick={onDotButtonClick}
              emblaApi={emblaApi}
            />
          </div>
        )}
      </div>
    </section>
  );
};
export default MeetTeam2;
